import { create } from "zustand";
import { baseURL, baseURLWithoutAPI } from "../../../baseUrl";
import axios from 'axios';
import Loader from "../../../components/Loader/Loder";
import { notification } from "antd";


export const useAuth = create((set, get) => ({
    isAuth: [],
    loader: false,
    userSideBarAccess: {},
    actions: {
        changePassword: async (currentPassword, newPassword, confirmNewPassword) => {
            set((state) => ({ loader: true }))
            await axios.post(`${baseURL}/Login/ChangePassword`,
                {
                    "currentPassword": currentPassword,
                    "newPassword": newPassword,
                    "confirmNewPassword": confirmNewPassword
                }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            }
            ).then((res) => {
                set((state) => ({ loader: false }))
                if (res.data !== false) {
                    notification.open({
                        icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                        </svg >,
                        message: 'عملیات موفق',
                        description:
                            'رمز عبور کاربر با موفقیت تغییر کرد',
                    })
                } else {
                    notification.open({
                        icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                        </svg >,
                        message: 'خطا',
                        description:
                            'تغییر رمز عبور با خطا مواجه شد',
                    })
                }

            }).catch((err) => {
                set((state) => ({ loader: false }))
                set((state) => ({ isAuth: err }))
            })
        },

        checkAuth: async (userName, pass) => {
            set((state) => ({ loader: true }))
            await axios.post(`${baseURL}/Login/Authenticate`,
                {
                    "userName": userName,
                    "password": pass
                }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            }
            ).then((res) => {
                set((state) => ({ loader: false }))
                if (res.status == 200) {
                    set((state) => ({ isAuth: true }))
                    localStorage.setItem("pelakToken", res.data.token)
                    localStorage.setItem("pelakUserId", res.data.code)
                }
            }).catch((err) => {
                set((state) => ({ loader: false }))

                set((state) => ({ isAuth: err }))
            })
        },
        getUserLogin: async (id) => {
            await axios.post(`${baseURL}/Login/GetUserLoginById`, {
                "id": id ? id : 0,
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            }
            )
                .then((res) => {
                    
                    set((state) => ({ userSideBarAccess: res.data }))
                })
        },
    }
}))

// export const todosGet = useGetTodos.setState